import * as React from 'react';
const classNames = require('classnames');

interface Props {
	className?: string;
	isDataTable?: boolean;
	disableScroll?: boolean;
	children?: {};
}

const RegularTable: React.StatelessComponent<any> = ({ isDataTable, ...props }) => {
	if (isDataTable) {
		return <div {...props} />;
	} else {
		return <table {...props} />;
	}
};

const Table: React.StatelessComponent<Props> = ({className, isDataTable, disableScroll = false, children}) => {
	return (
		<div className={classNames(className, { 'table-scroll-x': !disableScroll })}>
			<RegularTable isDataTable={isDataTable} className="table table-hover">
				{children}
			</RegularTable>
		</div>
	);
};

export default Table;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/common/Table.tsx